module.exports = __webpack_public_path__ + "img/assmat-recherche.c42dd759.jpg";